/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetGraphHistoryVersionService extends BaseService {
  constructor() {
    super(constants.GET_GRAPH_BY_OBJECT_ID, 'graphHistoryVersionStatus');
  }

  getErrorMessage(data, fallback) {
    return data?.error || data?.message || fallback;
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { objectId } = payload;

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/graphs/history/${objectId}`, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(`/graphs/history/${objectId}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const graphHistoryVersionModel = Framework.getStoreRegistry().getStore('graphHistoryVersionModel');

    if (data && (data.success === true || data.success === undefined)) {
      graphHistoryVersionModel.setGraphData(data);
    } else {
      const msg = this.getErrorMessage(data, 'Failed to fetch graph history version');
      graphHistoryVersionModel.setError(msg);
    }
  }

  handleError(error) {
    const graphHistoryVersionModel = Framework.getStoreRegistry().getStore('graphHistoryVersionModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      const msg = this.getErrorMessage(data, 'Failed to fetch graph history version');
      graphHistoryVersionModel.setError(msg);
    } else if (error.message === 'timeout of 60000ms exceeded') {
      graphHistoryVersionModel.setError('Request timeout. Please try again.');
    } else {
      const msg = error.message || 'Failed to fetch graph history version';
      graphHistoryVersionModel.setError(msg);
    }
  }
}
